"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Broadcast = void 0;
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var const_1 = require("../const");
var Broadcast = /** @class */ (function () {
    function Broadcast() {
        var _this = this;
        this.broadcast = null;
        this.eventBus = {};
        this.handleMap = {};
        var hostTopic = const_1.BROADCAST_CHANNEL_TOPIC;
        this.broadcast = new BroadcastChannel(hostTopic);
        // 同一个BroadcastChannel实例发送的message不能被监听到，所以需要重新实例化一个BroadcastChannel
        (new BroadcastChannel(hostTopic)).onmessage = function (messageEvent) {
            var _a = messageEvent.data, event = _a.event, data = _a.data;
            if (event) {
                if (_this.eventBus[event]) {
                    Object.keys(_this.eventBus[event]).forEach(function (handleId) {
                        _this.eventBus[event][handleId](data);
                    });
                }
            }
        };
    }
    Broadcast.prototype.on = function (event, callback) {
        if (!this.eventBus[event]) {
            this.eventBus[event] = {};
        }
        var handleId = (0, uniqueId_1.default)();
        this.eventBus[event][handleId] = callback;
        this.handleMap[handleId] = event;
        return handleId;
    };
    /** 制造一个事件 */
    Broadcast.prototype.emit = function (event, data) {
        this.broadcast.postMessage({
            event: event,
            data: data
        });
    };
    /** 取消一个订阅，如果传入句柄则取消某一个订阅 */
    Broadcast.prototype.off = function (eventOrHandleId) {
        if (this.eventBus[eventOrHandleId]) {
            delete this.eventBus[eventOrHandleId];
        }
        else {
            var event = this.handleMap[eventOrHandleId];
            if (event) {
                delete this.eventBus[event][eventOrHandleId];
                delete this.handleMap[eventOrHandleId];
            }
        }
    };
    return Broadcast;
}());
exports.Broadcast = Broadcast;
